<template>
  <section class="user-select-none">
    <div
      v-for="group in groups"
      :id="encodeURIComponent(group.name.replace(/\s+/g, '-').toLowerCase())"
      :key="group.id"
      class="product-group-row d-flex flex-column mb-4"
    >
      <CollarLeashProductStyles
        :action-link-text="actionLinkText"
        :always-show-all="showAllTags"
        :collar="isCollarGroup(group)"
        :group="group"
        :hide-header="hideHeader"
        :is-click-to-action-item="isClickToActionItem"
        :leash="isLeashGroup(group)"
        @onClick="redirectToStyle"
        aria-roledescription="carousel"
        role="group"
      />
    </div>
  </section>
</template>

<script>
import CollarLeashProductStyles from './CollarLeashProductStyles';
import { CollarLeashProductGroupMixins } from '@/mixins/components/productGroup';

export default {
  name: 'CollarLeashProductGroup',
  components: { CollarLeashProductStyles },
  mixins: [CollarLeashProductGroupMixins],
  props: {
    groups: {
      type: Array,
      required: true,
    },
    showAllTags: {
      type: Boolean,
      default: false,
      required: false,
    },
    actionLinkText: {
      type: String,
      required: false,
      default: null,
    },
    hideHeader: {
      type: Boolean,
      default: false,
      required: false,
    },
    isClickToActionItem: {
      type: Boolean,
      default: false,
      required: false,
    },
    redirectPath: {
      type: String,
      required: false,
      default: null,
    },
  },
};
</script>

<style lang="scss" scoped>
.product-group-row {
  .product-group-name {
    font-size: 2rem;
  }
}
</style>
